import React, { useEffect, useRef, useState } from "react";
import banner from '../assets/images/banner.png'
import { Link, useNavigate } from 'react-router-dom';

import ContactSection from './ContactSection';
import ReviewSlider from "./ReviewSlider";
import LoginModal from "./LoginModal";
import MainFooter from "./MainFooter";
import { useLocation } from "react-router-dom";

import aboutvenicon from "../assets/images/about-us-list-Van.svg";
import priceicon from "../assets/images/price.svg";
import safeicon from "../assets/images/safe.svg";
import supporticon from "../assets/images/support.svg";
import coinssimg from "../assets/images/coinss.svg";
import peopleicon from "../assets/images/people.svg";
import ven1 from "../assets/images/ven1.gif";
import ven2 from "../assets/images/ven2.png";
import ven3 from "../assets/images/ven3.png";
import bookven1 from "../assets/images/bookven1.png";
import bookven2 from "../assets/images/bookven2.gif";
import bookven3 from "../assets/images/bookven3.png";
import PopularCities from "./PopularCities";
import WowMomenets from "./WowMomenets";
import axios from "axios";

const Home = () => {
    const sectionRef = useRef(null);
    const [loginModalshow, setLoginModalshow] = useState(false);
    // Scroll function
    const scrollToSection = (ref) => {
        ref.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    const location = useLocation();
    const navigate = useNavigate();
    const handleScrollToSection = (path, sectionId) => {
        navigate(path);
        setTimeout(() => {
            const element = document.getElementById(sectionId);
            if (element) {
                const offset = window.innerWidth <= 768 ? 100 : 100;
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }, 100);

    };

    useEffect(() => {
        if (location.hash) {
            const sectionId = location.hash.replace("#", "");
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);


    const [packages, setPackages] = useState([]);
    const categoryLabels = ["Exclusive", "Most Popular", "Premium"]; // Static order

    const fetchPackages = async () => {
        try {
            const response = await axios.get("https://travel.viryawildlifetours.com/api/travel-packages");
            setPackages(response.data.data);
        } catch (err) {
            console.log("Failed to fetch travel packages");
        }
    };

    useEffect(() => {
        fetchPackages();
    }, []);

    console.log("packages", packages)

    return (
        <>
            <div className='container-fluid'>
                <div className='banner-top'>
                    <div className="row align-items-end">
                        <div className="col-lg-7 col-md-7">
                            <div className="bannerleft">
                                <h1>Transforming Car Travel <br /> Experience with <span>Memorable</span> <br /> Vrruksh Travels</h1>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-5">
                            <div className="bannerRight text-md-end text-center">
                                <p>Request <i className="bi bi-arrow-right mx-2"></i>  Hop On <i className="bi bi-arrow-right mx-2"></i> Travel <i className="bi bi-arrow-right mx-2"></i> Enjoy</p>
                                <div className="d-flex mt-3 mb-3 justify-content-md-end justify-content-center">
                                    <button className="btnbookprimary me-3" onClick={() => handleScrollToSection("/", "CarDetails")}>View Available Cars</button>
                                    <button className="btnbookprimary active" onClick={() => handleScrollToSection("/", "about")}>About Us</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="my-4">
                    <img src={banner} alt="" className="w-100" />
                </div>
                <div className="aboutSections bg-white my-5" id="about">
                    <div className='row mx-0 align-items-center' >
                        <div className='col-lg-4'>
                            <div className='aboutleftcontain'>
                                <h4>Why choose <br />
                                    Vrruksh Travels</h4>

                            </div>
                        </div>
                        <div className='col-lg-6 offset-lg-2'>
                            <div className='aboutrightcontain'>
                                <p>Vrruksh Travels specializes in personalized travel experiences. Our team carrying years of experience ensures every journey is seamless and memorable, tailored just for you.</p>
                                <button className="btnbookprimary me-3" onClick={() => handleScrollToSection("/", "WhatWeoffer")}>What we offer?</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="WhatWeoffer">
                    <div className="row" >
                        <div className="col-lg-4 mb-4">
                            <div className="whybox">
                                <div className="whytittle"> <img src={aboutvenicon} alt="" /> Versatile Fleet</div>
                                <p>Custom rides from compact to colossal, with all your favorite extras.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-4">
                            <div className="whybox">
                                <div className="whytittle"> <img src={coinssimg} alt="" /> Cost-Effective</div>
                                <p>Budget-friendly experience that’s worth every penny.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-4">
                            <div className="whybox">
                                <div className="whytittle"> <img src={supporticon} alt="" /> 24/7 Customer Support</div>
                                <p>Always on call, because your peace of mind is our top priority!</p>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-4">
                            <div className="whybox">
                                <div className="whytittle"> <img src={safeicon} alt="" /> Absolute Safety</div>
                                <p>Travel with a care—safety and smiles in every mile.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-4">
                            <div className="whybox">
                                <div className="whytittle"> <img src={priceicon} alt="" /> Hassle Free Booking</div>
                                <p>Experience the simplicity of booking—just a few clicks to your perfect ride.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-4">
                            <div className="whybox">
                                <div className="whytittle"> <img src={peopleicon} alt="" /> Personalised Service</div>
                                <p>Hosting Friends and Family? We have got the space for every face.</p>
                            </div>
                        </div>
                    </div>
                </div>








                <section className='convenience my-5 bg-white' id="TypesofCars">
                    <div className='row mx-0 text-center topconvenience'>

                        <h4>Our cars for your convenience. <br />All your travel needs captured</h4>
                        <p>From personal to professional, our car travel services are tailored for every unique situation.</p>
                    </div>
                    <div className="row mt-2 ">
                        {packages?.map((pkg) => (
                            <div className="col-lg-4 mt-4 mb-lg-0" key={pkg.id}>
                                <div className="conveniencebox">
                                    <img src={pkg.image} alt={pkg.name} />
                                    <div className="cardshadow"></div>
                                    <div className="d-flex justify-content-between bg-white p-md-3 p-2 rounded-3 align-items-center ">
                                        <h5 className="m-0">{pkg.name}</h5>
                                        <button className="btnbookprimary m-0" onClick={() => handleScrollToSection("/", "CarDetails")}>Explore</button></div>
                                </div>
                            </div>
                        ))}
                        {/* <div className="col-lg-4 mt-4 mb-lg-0">
                            <div className="conveniencebox">
                                <img src={ven3} alt="Image" />
                                <div className="cardshadow"></div>
                                <div className="d-flex justify-content-between bg-white p-md-3 p-2 rounded-3 align-items-center ">
                                    <h5 className="m-0">Toyota Innova Crysta</h5>
                                    <button className="btnbookprimary m-0" onClick={() => handleScrollToSection("/", "CarDetails")}>Explore</button></div>
                            </div>
                        </div>
                        <div className="col-lg-4 mt-4 mb-lg-0">
                            <div className="conveniencebox">
                                <img src={ven2} alt="Image" />
                                <div className="cardshadow"></div>
                                <div className="d-flex justify-content-between bg-white p-md-3 p-2 rounded-3 align-items-center ">
                                    <h5 className="m-0">Mahindra Scorpio S11 MT</h5>
                                    <button className="btnbookprimary m-0" onClick={() => handleScrollToSection("/", "CarDetails")}>Explore</button></div>
                            </div>
                        </div> */}

                    </div>

                </section>

                <section className='convenience my-5 bg-white' id="CarDetails" >
                    <div className='row mx-0 text-center topconvenience'>
                        <h4>Our Cars are Fully Prepared for Your Trip, <br />Anywhere across India</h4>
                        <p>What cars are you interested in? Check out the details and submit your booking enquiry now</p>
                    </div>
                    {/* <div className="row mt-4 ">
                        <div className="col-lg-4  mt-4 ">
                            <div className="bookcomfortbox">
                                <div className='topbook'>Exclusive</div>
                                <div className="Tripimg">
                                    <img src={bookven1} alt='bokok' />
                                    <div className="cardshadowbook"></div>
                                </div>
                                <h4>Maruti Suzuki Dezire</h4>
                                <p>Enjoy an exceptional fuel economy with The Dazzling-New Dzire. With amazing fuel efficiency of 25.71* km/l (in AGS), enjoy a drive beyond ordinary which is also economical.</p>
                                <h6>Key Specification</h6>
                                <ul>
                                    <li>25.71 kmpl Mileage</li>
                                    <li>382 Litres Boot Space</li>
                                    <li>5 Seating Capacity</li>
                                    <li>Petrol Fuel Type</li>
                                    <li>Automatic Transmission</li>
                                    <li>37 Litres Fuel Tank</li>

                                </ul>
                                <h6>What’s in There for You?</h6>
                                <ul className="carkeys">
                                    <li><i className="bi bi-check-circle-fill"></i> Air Conditioner</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Power Steering</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Passenger Airbag</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Alloy Wheels</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Automatic Climate Control</li>
                                    <li><span>...and comfort</span></li>
                                </ul>
                                <div className='bookcombtn' onClick={() => setLoginModalshow(true)}> Rent Maruti Suzuki Dezire <i className="bi bi-car-front-fill fs-5 ms-2"></i></div>
                            </div>
                        </div>


                        <div className="col-lg-4  mt-4 ">
                            <div className="bookcomfortbox">
                                <div className='topbook'>Most Popular</div>
                                <div className="Tripimg">
                                    <img src={bookven2} alt='bokok' />
                                    <div className="cardshadowbook"></div>
                                </div>
                                <h4>Toyota Innova Crysta</h4>
                                <p>The new Innova Crysta is not only powerful and comfortable, it’s safe too. The new Innova Crysta protects you and your family with 7 SRS Airbags during any eventuality.</p>
                                <h6>Key Specification</h6>
                                <ul>
                                    <li>25.71 kmpl Mileage</li>
                                    <li>382 Litres Boot Space</li>
                                    <li>5 Seating Capacity</li>
                                    <li>Petrol Fuel Type</li>
                                    <li>Automatic Transmission</li>
                                    <li>37 Litres Fuel Tank</li>

                                </ul>
                                <h6>What’s in There for You?</h6>
                                <ul className="carkeys">
                                    <li><i className="bi bi-check-circle-fill"></i> Air Conditioner</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Power Steering</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Passenger Airbag</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Alloy Wheels</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Automatic Climate Control</li>
                                    <li><span>...and comfort</span></li>
                                </ul>
                                <div className='bookcombtn' onClick={() => setLoginModalshow(true)}> Rent Maruti Suzuki Dezire <i className="bi bi-car-front-fill fs-5 ms-2"></i></div>
                            </div>
                        </div>

                        <div className="col-lg-4  mt-4 ">
                            <div className="bookcomfortbox">
                                <div className='topbook'>Premium</div>
                                <div className="Tripimg">
                                    <img src={bookven3} alt='bokok' />
                                    <div className="cardshadowbook"></div>
                                </div>
                                <h4>Mahindra Scorpio S11 MT</h4>
                                <p>7-seater powered by a 2184cc engine which is paired with a 6-speed manual transmission. Equipped with features such as multi-function steering wheel, front and more.</p>
                                <h6>Key Specification</h6>
                                <ul>
                                    <li>25.71 kmpl Mileage</li>
                                    <li>382 Litres Boot Space</li>
                                    <li>5 Seating Capacity</li>
                                    <li>Petrol Fuel Type</li>
                                    <li>Automatic Transmission</li>
                                    <li>37 Litres Fuel Tank</li>

                                </ul>
                                <h6>What’s in There for You?</h6>
                                <ul className="carkeys">
                                    <li><i className="bi bi-check-circle-fill"></i> Air Conditioner</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Power Steering</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Passenger Airbag</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Alloy Wheels</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Automatic Climate Control</li>
                                    <li><span>...and comfort</span></li>
                                </ul>
                                <div className='bookcombtn' onClick={() => setLoginModalshow(true)}> Rent Maruti Suzuki Dezire <i className="bi bi-car-front-fill fs-5 ms-2"></i></div>
                            </div>
                        </div>



                    </div> */}
                    <div className="row mt-4 ">
                        {packages?.map((pkg, index) => (
                            <div className="col-lg-4 mt-4" key={pkg.id}>
                                <div className="bookcomfortbox">
                                    <div className="topbook">{categoryLabels[index]}</div>
                                    <div className="Tripimg">
                                        <img src={pkg.image} alt={pkg.name} />
                                        <div className="cardshadowbook"></div>
                                    </div>
                                    <h4>{pkg.name}</h4>
                                    <div dangerouslySetInnerHTML={{ __html: pkg.description }}></div>

                                    <h6>Key Specifications</h6>
                                    <ul>
                                        {pkg.specification.split(",").map((spec, index) => (
                                            <li key={index}>{spec.trim()}</li>
                                        ))}

                                    </ul>

                                    <h6>What’s in There for You?</h6>
                                    <ul className="carkeys">
                                        {pkg.thereforyou.split(",").map((feature, index) => (
                                            <li key={index}>
                                                <i className="bi bi-check-circle-fill"></i> {feature.trim()}
                                            </li>
                                        ))}
                                        <li><span>...and comfort</span></li>
                                    </ul>

                                    <div className="bookcombtn" onClick={() => setLoginModalshow(true)}>
                                        Rent {pkg.name} <i className="bi bi-car-front-fill fs-5 ms-2"></i>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <div id="WhereweOperate">
                    <PopularCities handleScrollToSection={handleScrollToSection} />
                </div>
                <div id="Reviews">
                    <ReviewSlider />
                </div>
                <div id="wowmoments">
                    <WowMomenets />
                </div>
            </div>
            <div id="contact">
                <ContactSection />
            </div>
            <MainFooter />
            <LoginModal setLoginModalshow={setLoginModalshow} loginModalshow={loginModalshow} />

        </>
    )
}

export default Home;
